<div class="me-4 pe-2 fs-10 text-center">
    <span class="clickable text-dark" (click)="onCopyURL()" title="Copy URL">
      <img src="./assets/images/icons/copy-url-icon.svg" height="35px" alt="">
      <br>
      <span class="ps-2">&nbsp;URL</span>
    </span>
</div>
